import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TemplateDTO } from "../models/NotificationsModels/TemplateDTO";
import { SendEmailTemplateModel } from './../models/NotificationsModels/SendEmailTemplateModel';
import { EmailTemplateTesterModel } from "../models/NotificationsModels/EmailTemplateTesterModel";
import { SMSTemplateTesterModel } from "../models/NotificationsModels/SMSTemplateTesterModel";
import { TemplateEditViewModel } from "../models/NotificationsModels/TemplateEditViewModel";
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bnsights-utilities-library";

@Injectable({
    providedIn: 'root'
})
export class TemplateService {
    ApiUrl = "/api/admin/Templates/"
    constructor(private http: RequestHandlerService) {
    }

    Loaddropdowns() {
       
        return this.http.get( this.ApiUrl + 'Loaddropdowns');
      }
      
    AddEmailTemplate( AddModel: TemplateDTO) {
        return this.http.post( this.ApiUrl + 'AddTemplate', AddModel);
    }

    EditEmailTemplate( EditModel) {
        return this.http.post( this.ApiUrl +'EditTemplate', EditModel);
    }

    EditEmailTemplateByLang(EditModel:TemplateEditViewModel) {
      
        return this.http.post( this.ApiUrl +'EditEmailTemplate', EditModel);
    }


    EditSMSTemplateByLang( EditModel:TemplateEditViewModel) {
     
        return this.http.post( this.ApiUrl +'EditSMSTemplate', EditModel);
    }

    

    GenerateCodeAll() {
        return this.http.get( this.ApiUrl + 'GenerateCodeAll');
    }
    GenerateAllUpdateCode() {
        return this.http.get( this.ApiUrl + 'GenerateAllUpdateCode');
    }

    GenerateSysNames() {
        return this.http.get( this.ApiUrl + 'GenerateSysNames');
    }

    GenerateCodeById(templateId:number) {
        return this.http.post( this.ApiUrl + 'GenerateCodeById',templateId);
    }
    GenerateUpdateCodeById(templateId:number) {
        return this.http.post( this.ApiUrl + 'GenerateUpdateCodeById',templateId);
    }
    
    DeleteTemplate(id: number) {
      
        return this.http.post( this.ApiUrl + 'DeleteEmailTemplate', id);
    }


    GetTemplateInfo( id: number) {
       
        let params = new HttpParams();
        params = params.append("templateId", id.toString());
        return this.http.get( this.ApiUrl + 'GetTemplateInfo', params)
    }
    GetTemplateById(id: number) {
        
        let params = new HttpParams();
        params = params.append("templateId", id.toString());
        return this.http.get( this.ApiUrl + 'GetTemplateById', params)
    }

    GetTemplateInfoByLang(id: number,lang:string) {
       
        let params = new HttpParams();
        params = params.append("templateId", id.toString());
        params = params.append("lang", lang);
        return this.http.get( this.ApiUrl + 'GetTemplateInfoByLang', params)
    }


    GetSendEmailTemplate() {
    
        return this.http.get( this.ApiUrl + 'GetSendEmailTemplate',null)
    }

    GetTestSMSTemplate() {
       
        return this.http.get( this.ApiUrl + 'GetTestSMSTemplate',null)
    }



    SendEmailTemplate(model: SendEmailTemplateModel) {
      
        return this.http.post( this.ApiUrl + 'SendEmailTemplate', model);
    }

    TestSendEmailTemplate(model: EmailTemplateTesterModel) {
       
        return this.http.post( this.ApiUrl + 'TestTemplate', model);
    }

    TestSMSTemplate( model: SMSTemplateTesterModel) {
      
        return this.http.post( this.ApiUrl + 'TestSMSTemplate', model);
    }
}